import {Be3Entity} from '@app/models/v3/be3-entity';
import {LocalDate} from '@app/models/v3/local-date';
import {LocalTime} from '@app/models/v3/local-time';

export interface Coupon extends Be3Entity{
    name: string;
    courseId: string;
    courseName: string;
    start: LocalDate;
    end: LocalDate;
    status: CouponStatus;
    discountType: DiscountType;
    discount: number;
    applicableService: ApplicableServices;
    applicableDay: ApplicableDays;
    applicableTime: ApplicableTime;
    extraServices: string;
    cost: number;
    paidQuantity: number;
    availableQuantity: number;
    prefix: string;
    remark: string;
}

export enum CouponStatus {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    EXPIRED = 'EXPIRED',
    USED_UP = 'USED_UP',
    PENDING = 'PENDING'
}

export enum DiscountType {
    FIXED = 'FIXED',
    SERVICE = 'SERVICE'
}

export interface ApplicableServices {
    greenFee: boolean;
    cart: boolean;
    caddy: boolean;
}

export interface ApplicableDays {
    weekend: boolean;
    weekday: boolean;
}

export interface ApplicableTime {
    start: LocalTime;
    end: LocalTime;
}

export interface CouponItem extends Be3Entity {
    couponId: string;
    code: string;
    bookingId: string;
    invoiceNo: string;
    teeTime: Date | string;
    redeemDate: Date | string;
    cost: number;
    profit: number;
    remark: string;
}


